import React, { useReducer } from 'react';
import { reducer } from './reducer.esm.js';
import { ToastDispatchContext, ToastStateContext } from './ToastContext.esm.js';
import { Toasts } from './Toasts.esm.js';

function ToastProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, { toasts: [] });
    return (React.createElement(ToastDispatchContext.Provider, { value: {
            dispatch,
        } },
        React.createElement(ToastStateContext.Provider, { value: {
                state,
            } },
            React.createElement(Toasts, null),
            children)));
}

export { ToastProvider };
//# sourceMappingURL=ToastProvider.esm.js.map
